import { Location } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../services/local-storage.service";
import { iconsLibrary } from "../../../theme/constants";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { CoworkerService } from "../../services/coworker.service";
import { showAlertAction } from "../../store/actions/alert.action";
import { closeLoadingAction } from "../../store/actions/loading.action";

import { IAppState } from "../../store/state/app.state";
import { StateService } from "../../services/state.service";

@Component({
  selector: "cowing-core-coworker-confirmation",
  templateUrl: "./coworker-confirmation.component.html",
  styleUrls: ["./coworker-confirmation.component.scss"],
})
export class CoworkerConfirmationComponent implements OnInit {
  @Input("coworkingId") coworkingId = null;
  public bookingList = [];
  public lastBooking: any;
  @Input("bookingStates") bookingStates;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;

  public bookingConfirmationMode = false;
  constructor(
    private _router: Router,
    private translate: TranslateService,
    private _store: Store<IAppState>
    ) {
    _router.events.subscribe((val) => {
      // // see also

      if (val instanceof NavigationEnd) {
        if (val.url === "/booking-confirmation") {
          this.bookingConfirmationMode = true;
        } else {
          this.bookingConfirmationMode = false;
        }
      }
    });
  }
  async ngOnInit() {
    const coworkerId = LocalStorageService.instance.get(EStorageType.Coworker);
    try{
      const response = await CoworkerService.instance.getCoworkerBookings(coworkerId);
      this.bookingList = response;
      this.bookingList.sort(function(a,b){
        return (a.id - b.id)
      })
      this.lastBooking = this.bookingList[this.bookingList.length - 1];
    } catch (e) {
      if (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );        
      }
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
    
  }

  public redirectToBookings() {
    this._router.navigate(["coworker-booking"]);
  }
  public get getConfirmation() {
    return `${iconsLibrary.confirm}`;
  }
}
